module.exports = __webpack_public_path__ + "img/trophy.b65f2cb0.gif";